import { gsap } from "gsap";
import { isSP } from "../../common/functions/isSP.es6";
import Swiper from "swiper/bundle";

export default class Stage {
  constructor() {
    this.phLength = {
      top: 8,
      bottom: 6,
    };
    this.photoLengthBottom = 6;
    this.initalized = false;
    this.setObserver();
    this.setStageSlide();
  }

  init() {
    this.setDom();
    this.setStream();
    this.initalized = true;
  }

  setDom() {
    const themeDir = "/wp/wp-content/themes/brotherash_official/";

    const createStream = (position = "top") => {
      const streamWrapper = document.querySelector(
        `.stage__phstream__itemwrap[data-id="${position}"]`
      );

      for (let k = 0; k < 3; k++) {
        const wrapper = document.createElement("div");
        wrapper.classList.add("unit");

        for (let i = 1; i < this.phLength[position]; i++) {
          const phdom = document.createElement("div");
          phdom.classList.add("stage__phstream__item");
          const img = document.createElement("img");
          img.src = `${themeDir}assets/img/top/stage/stream_${position}/ph_${i}.webp`;
          phdom.appendChild(img);
          wrapper.appendChild(phdom);
        }

        streamWrapper.appendChild(wrapper);
      }
    };

    createStream("top");
    createStream("bottom");
  }

  setObserver() {
    const targetObjects = [...document.querySelectorAll(".stage")];

    const options = {
      threshold: 0,
    };

    // コールバックの受け取り
    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          //console.log(`STAGE交差`);

          if (!this.initalized) {
            this.init();
          }
        } else {
        }
      });
    };

    // IntersectionObserverオブジェクトを作る
    const observerObject = new IntersectionObserver(callback, options);

    // 監視対象の監視を開始する
    targetObjects.forEach((object) => {
      observerObject.observe(object);
    });
  }

  setStream() {
    const duration = isSP() ? 80 : 120;
    const stream1 = document.querySelector(
      '.stage__phstream__itemwrap[data-id="top"]'
    );
    const stream2 = document.querySelector(
      '.stage__phstream__itemwrap[data-id="bottom"]'
    );

    gsap.fromTo(
      stream1,
      { x: "0%" },
      {
        x: "-33.33333333%",
        duration: duration,
        repeat: "-1",
        ease: "none",
      }
    );

    gsap.fromTo(
      stream2,
      { x: "-33.33333333%" },
      {
        x: "0%",
        duration: (duration * (3380.34 * 0.5)) / (9492.13 * 0.5),
        repeat: "-1",
        ease: "none",
      }
    );
  }

  setStageSlide() {
    const swiper = new Swiper(".swiper", {
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: ".swiper-pagination",
      },

      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}
